import Chart from "react-apexcharts";

const PieChart = ({ series, options }) => {
  return (
    <Chart
      options={options}
      series={series}
      type="pie"          // or "donut"
      width="100%"
      height="100%"
      redrawOnResize={true} // ensures responsiveness
    />
  );
};

export default PieChart;